import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useMixins } from '@/modules/promotion/plan/model/mixins';
import { promotionService } from '@/services/promotion';

export function usePromotionPlanList() {
    const crudAction = useCrudActions();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { fetchLinkableItems, getItemName, getItemLink } = useMixins();

    const { list, total, fetchList } = useBaseListView({
        request: promotionService.plan.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            loadInitialData: async () => await fetchLinkableItems(),
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute,
            transformResponse: (list: any[]) =>
                list.map(promotionPlan => ({
                    ...promotionPlan,
                    linkedItemName: getItemName(promotionPlan.itemId, promotionPlan.type),
                    linkedItemLink: getItemLink(promotionPlan.itemId, promotionPlan.type)
                }))
        }
    });

    const actions = {
        disable: crudAction.confirmAndDisable({
            request: promotionService.plan.disable,
            onSuccess: () => fetchList()
        }),
        enable: crudAction.confirmAndEnable({
            request: promotionService.plan.enable,
            onSuccess: () => fetchList()
        }),
        remove: crudAction.confirmAndRemove({
            request: promotionService.plan.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, query, fetchList, actions };
}
